import axios from "axios";
import { useCallback } from "react";

function usePost() {
  const apiKey = process.env.REACT_APP_API_KEY;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const post = useCallback(
    async (
      endpoint: string,
      bodyData: { [key: string]: string | number | null }
    ) => {
      try {
        const response = await axios.post(baseUrl + endpoint, bodyData, {
          headers: {
            Authorization: apiKey,
          },
        });
        return response.data;
      } catch (error) {
        console.error("There was an error!", error);
        throw error;
      }
    },
    [baseUrl, apiKey]
  );

  const patch = useCallback(
    async (
      endpoint: string,
      bodyData: { [key: string]: string | number | null }
    ) => {
      try {
        const response = await axios.patch(baseUrl + endpoint, bodyData, {
          headers: {
            Authorization: apiKey,
          },
        });
        return response.data;
      } catch (error) {
        console.error("There was an error!", error);
        throw error;
      }
    },
    [baseUrl, apiKey]
  );

  return { post, patch };
}

export default usePost;
